import React from "react";

interface NumberInputProps {
  label: string;
  value: number;
  placeholder?: string;
  unit?: string;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  errorMessage?: string;
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  value,
  placeholder,
  unit,
  onChange,
  min,
  max,
  errorMessage,
}) => {
  const hasError = value !== null && (value < min! || value > max!);
  return (
    <div className="mb-4">
      <label className="block text-sm font-bold mb-1">{label}</label>
      <div className="flex items-center">
        <input
          type="number"
          value={value === 0 ? "" : value}
          placeholder={placeholder}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          className={`w-11/12 p-2 border rounded ${hasError ? "border-red-500" : ""}`}
        />
        {unit && <span className="ml-2 text-[14px]">{unit}</span>}  
      </div>
      {hasError && (
        <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
};


export default NumberInput;
